import { motion } from 'framer-motion';
import { Zap, TrendingDown, Phone, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const DualCTASection = () => {
  return (
    <section id="kontakt" className="py-20 lg:py-32">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16">

          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-4">
            Starten Sie jetzt
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Wählen Sie den für Sie passenden Weg – wir sind bereit
          </p>
        </motion.div>

        {/* Dual CTA Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto items-stretch">
          {/* FastLane CTA */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative group h-full">

            <div className="absolute inset-0 bg-gradient-fastlane rounded-2xl blur-xl opacity-30 group-hover:opacity-50 transition-opacity" />
            <div className="relative bg-gradient-fastlane rounded-2xl p-8 lg:p-12 text-center overflow-hidden h-full flex flex-col">
              {/* Background Pattern */}
              <div className="absolute inset-0 pattern-blueprint opacity-10" />

              <div className="relative z-10 flex flex-col h-full">
                <div className="w-20 h-20 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-6">
                  <Zap className="w-10 h-10 text-white" />
                </div>

                <h3 className="font-heading font-bold text-2xl lg:text-3xl text-white mb-3">
                  Eilig? FastLane nutzen!
                </h3>
                <p className="text-white/80 text-lg mb-6 md:mb-8">
                  Direkter Ansprechpartner meldet sich in Minuten
                </p>

                <div className="space-y-4 mt-auto pt-2">
                  <Button
                    variant="secondary"
                    size="xl"
                    className="w-full bg-white text-primary hover:bg-white/90 gap-2"
                    asChild>

                    <a href="tel:+4994669115130">
                      <Phone className="w-5 h-5" />
                      09466 / 911 51 30
                    </a>
                  </Button>
                  <Button
                    variant="heroSecondary"
                    size="xl"
                    className="w-full gap-2"
                    asChild>

                    <a href="/anfrage?type=fastlane">
                      FastLane Formular
                      <ArrowRight className="w-5 h-5" />
                    </a>
                  </Button>
                </div>

                <p className="text-white/60 text-sm mt-6">
                  Mo-Fr 7:00-16:00 Uhr | Heute noch Fertigung möglich
                </p>
              </div>
            </div>
          </motion.div>

          {/* Smart Production CTA */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative group h-full">

            <div className="absolute inset-0 bg-gradient-smart rounded-2xl blur-xl opacity-30 group-hover:opacity-50 transition-opacity" />
            <div className="relative bg-gradient-smart rounded-2xl p-8 lg:p-12 text-center overflow-hidden h-full flex flex-col">
              {/* Background Pattern */}
              <div className="absolute inset-0 pattern-blueprint opacity-10" />

              <div className="relative z-10 flex flex-col h-full">
                <div className="w-20 h-20 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-6">
                  <TrendingDown className="w-10 h-10 text-white" />
                </div>

                <h3 className="font-heading font-bold text-2xl lg:text-3xl text-white mb-3">
                  Kosten sparen? Smart Production!
                </h3>
                <p className="text-white/80 text-lg mb-8">
                  Liefertermin angeben und bis zu 40% sparen
                </p>

                <div className="space-y-4 mt-auto">
                  <Button
                    variant="secondary"
                    size="xl"
                    className="w-full bg-white text-smart hover:bg-white/90 gap-2"
                    asChild>

                    <a href="/anfrage?type=smart">
                      <TrendingDown className="w-5 h-5" />
                      Kostenoptimierte Anfrage
                    </a>
                  </Button>
                  <Button
                    variant="heroSecondary"
                    size="xl"
                    className="w-full gap-2"
                    asChild>

                    <a href="/anfrage?type=smart">
                      .STEP-Datei hochladen
                      <ArrowRight className="w-5 h-5" />
                    </a>
                  </Button>
                </div>

                <p className="text-white/60 text-sm mt-6">
                  Flexible Liefertermine | Volle Qualität
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>);

};

export default DualCTASection;